import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [token, setToken] = useState("");
  const [authed, setAuthed] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async (e) => {
    e?.preventDefault();
    setLoading(true);
    try {
      const res = await axios.get(`${API}/enquiries`, { headers: { "X-Admin-Token": token } });
      setItems(res.data);
      setAuthed(true);
    } catch {
      toast.error("Invalid access token.");
    } finally {
      setLoading(false);
    }
  };

  if (!authed) {
    return (
      <div data-testid="admin-login" className="min-h-screen bg-[#1A1A1A] text-[#FBF9F6] flex items-center justify-center px-6">
        <form onSubmit={load} className="w-full max-w-sm">
          <div className="font-serif text-4xl tracking-tight mb-2">Simpliq Atelier</div>
          <p className="eyebrow mb-8">Enquiries · Admin</p>
          <input
            data-testid="admin-token-input"
            type="password"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="Access token"
            className="w-full bg-transparent border-b border-[#555] py-3 focus:outline-none focus:border-[#FBF9F6] transition-colors mb-8"
          />
          <button data-testid="admin-login-btn" disabled={loading} className="bg-[#FBF9F6] text-[#1A1A1A] px-8 py-3 rounded-full text-sm hover:bg-[#8C7A6B] hover:text-white transition-colors duration-500">
            {loading ? "Checking…" : "Enter"}
          </button>
        </form>
      </div>
    );
  }

  return (
    <div data-testid="admin-dashboard" className="min-h-screen bg-[#FBF9F6] py-16 px-6 md:px-12">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-end justify-between mb-12">
          <div>
            <div className="font-serif text-4xl md:text-5xl tracking-tight">Enquiries</div>
            <p className="eyebrow mt-2">{items.length} total</p>
          </div>
          <button onClick={load} className="text-sm link-underline">Refresh</button>
        </div>

        {items.length === 0 ? (
          <p className="text-[#5C5A56]">No enquiries yet.</p>
        ) : (
          <div className="space-y-4">
            {items.map((it) => (
              <div key={it.id} data-testid="admin-enquiry" className="bg-white border border-[#E5E0D8] p-6 md:p-8">
                <div className="flex flex-wrap justify-between gap-2 mb-4">
                  <div className="font-serif text-2xl tracking-tight">{it.name}</div>
                  <div className="text-xs text-[#8C7A6B] tracking-widest">{new Date(it.created_at).toLocaleString()}</div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-sm text-[#5C5A56] mb-4">
                  <a href={`mailto:${it.email}`} className="link-underline">{it.email}</a>
                  <span>{it.phone || "—"}</span>
                  <span>{it.project_type || "—"}</span>
                </div>
                <p className="text-[#1A1A1A] leading-relaxed whitespace-pre-wrap">{it.message}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
